import { Component, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  Validators,
  UntypedFormGroup,
} from "@angular/forms";
import { ToastService } from "@core/components/toasts/toasts.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ListAbstract } from "app/views/pages/abstract/list-abstract";

import { convertToUpperCase } from "utils/helps";
import { WorkforceplanTrainingService } from "services/workforceplan/workforceplan-training.service";
import { TrainingTypeModel } from "services/models/trainingType.model";

@Component({
  selector: 'app-workforce-plan-modal',
  templateUrl: './workforce-plan-modal.component.html',
  styleUrls: ['./workforce-plan-modal.component.scss']
})
export class WorkforcePlanModalComponent
  extends ListAbstract<TrainingTypeModel, WorkforceplanTrainingService>
  implements OnInit {
  title = "";
  form: UntypedFormGroup;
  fields: any[] = ["Editar", "Nome", "Criação", "Valida Orgânico?", "É Aptidão?"];
  trainings: TrainingTypeModel[] = [];
  formTitle: string = "Novo Treinamento";
  convertToUpperCase = convertToUpperCase;
  currentTraining: TrainingTypeModel;
  constructor(
    public service: WorkforceplanTrainingService,
    private formBuilder: UntypedFormBuilder,
    private toaster: ToastService,
    public activeModal: NgbActiveModal,

  ) {
    super(service);
    this.queryParams.select = this.fieldParams;
  }

  ngOnInit() {
    this.listTrainings();
    this.initializeForm();
  }

  onDismiss(): void {
    this.activeModal.close();
  }

  initializeForm() {
    this.form = this.formBuilder.group({
      name: ["", [Validators.required]],
      validateHeadcountPlanning: [false],
      isAptitude: [false]
    });
  }

  listTrainings() {
    this.service.listTrainings().subscribe((res) => {
      this.trainings = res.data;
    });
  }

  patchLevelValue(id: any) {
    this.formTitle = "Editando Treinamento";
    this.currentTraining = this.trainings.find((x) => x.id == id);
    this.form.patchValue(this.currentTraining);
    this.form.updateValueAndValidity();
  }

  handleSubmit() {
    if (this.form.valid) {
      const object = TrainingTypeModel.create(this.form?.value);
      object.id = this.currentTraining?.id;
      this.convertToUpperCase(object);
      this.service.saveTraining(object.id, object).subscribe((res) => {
        setTimeout(() => {
          this.listTrainings(); // Força a atualização com um pequeno atraso
        }, 500);
        this.toaster.showSuccess("Treinamento salvo com sucesso...");
        this.cleanForm();
      });
    } else {
      this.toaster.showWarning(
        "Formulário incompleto! Preencha para continuar."
      );
    }
  }


  cleanForm() {
    this.formTitle = "Novo Treinamento";
    this.currentTraining = null;
    this.form.reset();
    this.onDismiss();
  }
}
